import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { calculateFreightFailure } from '../../store/ducks/freight/actions';

interface IRegisterFreigthData {
  freightRequestId: string;
  distributorId?: string;
  deliveryLimitDate?: string;
  percentageFreightCost?: number;
}

export function useRegisterFreights() {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();

  async function execute(data: IRegisterFreigthData) {
    try {
      setLoading(true);

      /*       const payload = {
        freightRequestId: data.freightRequestId,
        deliveryLimitDate: data.pickUpDate,
        totalDeliveries: data.totalDeliveries,
        totalWeight: data.totalWeight,
        numberOfHelpers: data.numberOfHelpers,
        vehicleTypeId: data.vehicleTypeId,
        totalValue: data.totalValue,
        freightCost: data.freightCost,
        vehicleTypePrice: data.vehicleTypePrice,
        loadNumber: data.loadNumber,
        driverId: data.driverId,
      }; */

      const response = await api.post('v1/backoffice/freights', data);

      if (response.status === 201) {
        toast.success(ToastMessages.freight.success.registerFreight);
        dispatch(calculateFreightFailure());
      }
      return response;
    } catch (error) {
      console.error(error);
      toast.error(ToastMessages.general.error.genericError);
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
